"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouter = require("react-router");
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _selectors = require("@otpusk/apisearch-toolbox/dist/offers/selectors");
var _actions = require("../../../bus/ui/actions");
var _config = require("../../../services/config");
var _OfferDetails = _interopRequireDefault(require("../../Results/components/OfferDetails/OfferDetails"));
var _actions2 = require("../../Results/components/OfferDetails/store/actions");
var _Loader = _interopRequireDefault(require("../../ui/Loader"));
var _Alert = _interopRequireWildcard(require("../../ui/Alert"));
var _BasketCounter = require("../../Baskets/components/BasketCounter");
var _actions3 = require("./store/actions");
var _selectors2 = require("./store/selectors");
var _constants = require("./store/constants");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var OfferPage = function OfferPage() {
  var _useParams = (0, _reactRouter.useParams)(),
    hotelID = _useParams.hotelID,
    offerID = _useParams.offerID;
  var ui = (0, _reactRedux.useSelector)(_selectors2.getPageUI);
  var getOfferSelector = (0, _react.useCallback)(function (state) {
    return (0, _selectors.getOffer)()(state, {
      offerID: offerID
    });
  }, [offerID]);
  var offer = (0, _reactRedux.useSelector)(getOfferSelector);
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)('OFFER_PAGE'),
    t = _useTranslation.t;
  var memoHandleClickByChartBar = (0, _react.useCallback)(function (momentDate) {
    return dispatch((0, _actions3.handleClickByChartBar)(momentDate));
  }, [dispatch]);
  var memoOpenMap = (0, _react.useCallback)(function () {
    dispatch((0, _actions2.openMap)(hotelID !== null && hotelID !== void 0 ? hotelID : offer === null || offer === void 0 ? void 0 : offer.hotelId, offerID));
  }, [dispatch, hotelID, offerID, offer]);
  var normalizedHotelId = hotelID ? Number(hotelID) : offer === null || offer === void 0 ? void 0 : offer.hotelId;
  (0, _react.useEffect)(function () {
    dispatch((0, _actions3.bootstrap)());
    return function () {
      dispatch((0, _actions.unRegister)(_constants.UI_KEY));
    };
  }, [dispatch]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ui.loading && /*#__PURE__*/_react.default.createElement(_Loader.default, {
    label: t('LOADING')
  }), ui.completed && !ui.error && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !(0, _config.isTouristMode)() && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.cartsContainer
  }, (0, _config.getOnGetBaskets)() && /*#__PURE__*/_react.default.createElement(_BasketCounter.BasketCounter, null)), /*#__PURE__*/_react.default.createElement(_OfferDetails.default, {
    className: _styles.default.offerDetails,
    hotelID: normalizedHotelId,
    offerID: offerID,
    onClickByChartBar: memoHandleClickByChartBar,
    onOpenMap: memoOpenMap
  })), ui.error && /*#__PURE__*/_react.default.createElement(_Alert.default, {
    type: _Alert.TYPES.ERROR
  }, ui.message));
};
var _default = exports.default = OfferPage;